import React from 'react';
import { DateRow, LocalDateRow, SearchAndFilerFull, SimpleTooltip, TextRow } from '../../../components';
import { Images, PermissionList, renderStaffName, RolePermission } from '../../../utils';
import { Checkbox, CircularProgress } from '@mui/material';
import moment from 'moment/moment';

const label = { inputProps: { 'aria-label': 'Color switch demo' } };

export const resourceTabsLabels = [{ label: 'Files' }, RolePermission([PermissionList.MANAGE_RESOURCE?.code]) && { label: 'Access' }];

export const accessHead = (handleSelect, fullList, selected, disabled) => {
    return [
        { name: 'staffFullName', title: 'Staff', custom: false },
        {
            renderView: (
                <div>
                    <div className="flex-align-center" style={{ gap: 8, marginBottom: '-4px' }}>
                        <SimpleTooltip title="Apply to all" placement="top">
                            <Checkbox
                                {...label}
                                onClick={(e) => handleSelect(e, 'upload', 'all')}
                                name={'checkBox'}
                                style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
                                disabled={disabled}
                                checked={fullList?.length === selected?.upload?.length}
                            />
                        </SimpleTooltip>

                        <p>Upload</p>
                    </div>
                    <SearchAndFilerFull item={{ custom: false, name: 'upload', disabled: true }} />
                </div>
            ),
        },
        {
            renderView: (
                <div>
                    <div className="flex-align-center" style={{ gap: 8, marginBottom: '-4px' }}>
                        <SimpleTooltip title="Apply to all" placement="top">
                            <Checkbox
                                {...label}
                                onClick={(e) => handleSelect(e, 'download', 'all')}
                                name={'checkBox'}
                                style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
                                disabled={disabled}
                                checked={fullList?.length === selected?.download?.length}
                            />
                        </SimpleTooltip>
                        <p>Download</p>
                    </div>
                    <SearchAndFilerFull item={{ custom: false, name: 'download', disabled: true }} />
                </div>
            ),
        },
        {
            renderView: (
                <div>
                    <div className="flex-align-center" style={{ gap: 8, marginBottom: '-4px' }}>
                        <SimpleTooltip title="Apply to all" placement="top">
                            <Checkbox
                                {...label}
                                onClick={(e) => handleSelect(e, 'delete', 'all')}
                                name={'checkBox'}
                                style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
                                disabled={disabled}
                                checked={fullList?.length === selected?.delete?.length}
                            />
                        </SimpleTooltip>
                        <p>Delete</p>
                    </div>
                    <SearchAndFilerFull item={{ custom: false, name: 'delete', disabled: true }} />
                </div>
            ),
        },
        { name: '', title: 'Granted On', custom: false },
    ];
};

export const accessBody = (handleSelect, selected, disabled) => [
    {
        rowText: (item) => <TextRow name={item?.staffFullName} />,
    },
    {
        rowText: (item) => (
            <Checkbox
                {...label}
                onClick={() => handleSelect(item, 'upload')}
                name={'checkBox'}
                style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
                disabled={disabled}
                checked={selected?.upload?.includes(item?.staffId)}
            />
        ),
    },
    {
        rowText: (item) => (
            <Checkbox
                {...label}
                onClick={() => handleSelect(item, 'download')}
                name={'checkBox'}
                style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
                disabled={disabled}
                checked={selected?.download?.includes(item?.staffId)}
            />
        ),
    },
    {
        rowText: (item) => (
            <Checkbox
                {...label}
                onClick={() => handleSelect(item, 'delete')}
                name={'checkBox'}
                style={{ padding: 0, color: '#347AF0', opacity: disabled ? 0.5 : 1 }}
                disabled={disabled}
                checked={selected?.delete?.includes(item?.staffId)}
            />
        ),
    },
    {
        rowText: (item) =>
            item?.grantedOn && item?.grantedBy ? (
                <div>
                    <DateRow date={item?.grantedOn} />
                    <TextRow name={`${moment(item?.grantedOn).format('hh:mm a')} by ${item?.grantedBy}`} />
                </div>
            ) : (
                '--'
            ),
    },
];

export const ACCESS_ACTION_TYPE = 'GET_RESOURCE_ACCESS';

export const accessNotYet = {
    title: 'No Files Added Yet',
    subTitle: 'Start adding your files.',
    image: Images.noFsYet,
};

export const resourceFilesHead = (noSearch, userAccess) => {
    const editAccess = RolePermission([PermissionList.MANAGE_RESOURCE?.code]) || userAccess?.upload;
    const downloadAccess = RolePermission([PermissionList.MANAGE_RESOURCE?.code]) || userAccess?.download;
    const deleteAccess = RolePermission([PermissionList.MANAGE_RESOURCE?.code]) || userAccess?.delete;

    return [
        { name: 'name', title: 'Document Name', custom: false, noSearch: noSearch },
        { name: 'description', title: 'Document Description', custom: false, noSearch: noSearch },
        { name: 'date', title: 'Date Uploaded', custom: false, disabled: true, noSearch: noSearch },
        { name: '', title: 'File Type', custom: false, disabled: true, width: '150px', noSearch: noSearch },
        (editAccess || downloadAccess || deleteAccess) && {
            name: '',
            title: 'Action',
            custom: false,
            disabled: true,
            width: '230px',
            noSearch: noSearch,
        },
    ];
};

const renderFileTypeAndColor = (file) => {
    const background =
        file === 'svg+xml'
            ? '#FFCA33'
            : file === 'jpeg'
              ? '#51439E'
              : file === 'jpg'
                ? '#51439E'
                : file === 'png'
                  ? '#155EEF'
                  : file === 'pdf'
                    ? '#CC400C'
                    : '#FFCA33';

    const text =
        file === 'svg+xml'
            ? 'SVG'
            : file === 'jpeg'
              ? 'JPEG'
              : file === 'jpg'
                ? 'JPG'
                : file === 'png'
                  ? 'PNG'
                  : file === 'pdf'
                    ? 'PDF'
                    : file;

    return (
        <div>
            <div className="file-type-box" style={{ background: background }}>
                {text}
            </div>
        </div>
    );
};
export const resourceFilesBody = (selectedId, userAccess) => {
    const editAccess = RolePermission([PermissionList.MANAGE_RESOURCE?.code]) || userAccess?.upload;
    const downloadAccess = RolePermission([PermissionList.MANAGE_RESOURCE?.code]) || userAccess?.download;
    const deleteAccess = RolePermission([PermissionList.MANAGE_RESOURCE?.code]) || userAccess?.delete;

    return [
        {
            rowText: (item) => <TextRow name={item?.name} textWidth={9} />,
        },
        {
            rowText: (item) => <TextRow name={item?.description} textWidth={9} />,
        },
        {
            rowText: (item) => <LocalDateRow date={item?.uploadedDate} />,
            // rowText: (item) => <DateRow date={item?.uploadedDate} />,
        },
        {
            rowText: (item) => <div>{renderFileTypeAndColor(item?.file?.format)}</div>,
        },
        (editAccess || downloadAccess || deleteAccess) && {
            button: (fun, item) => (
                <div className={'document-actions'}>
                    {editAccess && (
                        <button onClick={() => fun('edit')}>
                            <img src={Images.edit} alt={'icon'} />
                        </button>
                    )}
                    {downloadAccess && (
                        <a href={item?.file?.url} target={'_blank'} rel="noopener noreferrer">
                            <button>
                                <img src={Images.showEye} alt={'icon'} />
                            </button>
                        </a>
                    )}
                    {downloadAccess && (
                        <button onClick={() => fun('download')} style={{ position: 'relative' }}>
                            {selectedId === item?._id || selectedId === item?.id ? (
                                <CircularProgress
                                    style={{
                                        color: '#172B4D',
                                        width: '15px',
                                        height: '15px',
                                        margin: '-8px 0 0 -8px',
                                        position: 'absolute',
                                    }}
                                />
                            ) : (
                                <img src={Images.downloadPdf} alt={'icon'} />
                            )}
                        </button>
                    )}
                    {deleteAccess && (
                        <button onClick={() => fun('delete')}>
                            <img src={Images.trash} alt={'icon'} />
                        </button>
                    )}
                </div>
            ),
            notClickable: true,
        },
    ];
};

export const resourceFileNotYet = {
    title: 'No Files Uploaded',
    subTitle: 'Upload files to store relevant documents here.',
    image: Images.notFile,
};
